export default __webpack_public_path__ + "static/media/innovate-uk.3899bc66.png";